"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.TreeviewFolder = void 0;
var React = require("react");
var __1 = require("../..");
var _Core_1 = require("../../_Core");
var keyboard = require("../../_Core/Keyboard");
var Styles_1 = require("./Styles");
var indicatorIcons = {
    Height: "16px",
    Width: "16px",
};
var TreeviewFolder = function (props) {
    var folderForwardRef = React.createRef();
    var _a = React.useState(props.Item ? (props.Item.Children && props.Item.Children.length > 0) : false), hasLoaded = _a[0], setHasLoaded = _a[1];
    var isExpanded = props.Item.IsExpanded || false;
    var _b = React.useState(false), isLoading = _b[0], setIsLoading = _b[1];
    var handleOnExpandCollapse = function (item, isExpand) {
        props.OnExpandCollapse(item, isExpand);
    };
    var handleOnKeyDown = function (e) {
        var _a;
        if (keyboard.IsUpArrow(e) || keyboard.IsDownArrow(e)) { // navigate items
            e.stopPropagation();
            e.preventDefault();
            props.OnKeyDownEvent(e);
        }
        else if (keyboard.IsSpace(e) || keyboard.IsEnter(e)) { // toggle expand/collapse
            e.stopPropagation();
            e.preventDefault();
            toggleIsExpandedState();
            (_a = folderForwardRef.current) === null || _a === void 0 ? void 0 : _a.FireAddClick();
        }
        else if (keyboard.IsRightArrow(e)) { // Expand
            e.stopPropagation();
            e.preventDefault();
            handleOnExpandCollapse(props.Item, true);
        }
        else if (keyboard.IsLeftArrow(e)) { // Collapse
            e.stopPropagation();
            e.preventDefault();
            handleOnExpandCollapse(props.Item, false);
        }
    };
    var handleExpandContractClick = function (e) {
        var _a;
        e.stopPropagation();
        e.preventDefault();
        toggleIsExpandedState();
        (_a = folderForwardRef.current) === null || _a === void 0 ? void 0 : _a.FireAddClick();
    };
    var toggleIsExpandedState = function () {
        if (isExpanded) {
            // this is expanded so we can just close this.
            handleOnExpandCollapse(props.Item, !isExpanded);
        }
        else if (!props.Item.LazyLoadChildren || hasLoaded) {
            handleOnExpandCollapse(props.Item, !isExpanded);
        }
        else {
            setIsLoading(true);
            setHasLoaded(false);
            props.OnDataRequest(props.Item).then(function () {
                setIsLoading(false);
                setHasLoaded(true);
                handleOnExpandCollapse(props.Item, true);
            });
        }
    };
    return (props.Item &&
        React.createElement(Styles_1.TreeItem, { key: props.Item.UniqueID, role: "treeitem", onClick: handleExpandContractClick, onKeyDown: handleOnKeyDown, onFocus: props.OnFocusEvent, tabIndex: props.FirstElement ? 0 : -1, "aria-expanded": isExpanded, fullWidthFocusStyling: props.FullWidthFocusStyling, isSelected: props.SelectedItemID === props.Item.UniqueID },
            React.createElement(Styles_1.TreeItemCaption, null,
                React.createElement(Styles_1.TreeItemIconWrapper, null, props.Item.Children && props.Item.Children.length > 0 &&
                    (isLoading ? React.createElement(Styles_1.TreeItemLoader, null) :
                        !isExpanded ?
                            React.createElement(__1.Icon, __assign({ Icon: _Core_1.Icons.CaretRight }, indicatorIcons)) :
                            React.createElement(__1.Icon, __assign({ Icon: _Core_1.Icons.CaretDown }, indicatorIcons)))),
                React.createElement(Styles_1.TreeItemStretchCaption, null, props.RenderFolder(props.Item, folderForwardRef))),
            isExpanded ?
                React.createElement(Styles_1.ChildrenGroup, { role: "group", IndentAmount: props.IndentAmount, SpaceAfterGroup: props.SpaceAfterGroup }, props.children) : null));
};
exports.TreeviewFolder = TreeviewFolder;
